import { computed, effect, signal } from "@preact/signals-react";
import { userData } from "../../Common/Store/CommonSignals";

export const selectedHamburgerIndex = signal(getHamburgerIndex());
export const isExpanded = signal(false);
export const isDialogVisible = signal(false);
export const pendingRoute = signal();

function getHamburgerIndex() {
  const hamburgerIndex = localStorage.getItem("HAMBURGER_INDEX");
  return Number(hamburgerIndex) || 1;
}
effect(() => {
  localStorage.setItem("HAMBURGER_INDEX", selectedHamburgerIndex.value);
});

export const items = computed(() => [
  {
    icon: isExpanded.value ? "k-i-chevron-left" : "k-i-hamburger",
    title: isExpanded.value ? "Collapse" : "Expand",
    id: 0,
    showImage: true,
    expanded: isExpanded.value,
  },
  {
    separator: true,
  },
  {
    icon: "k-i-home",
    route: "/",
    title: "Home",
    label: "Home",
    id: 1,
    selected: selectedHamburgerIndex.value === 1,
  },
  {
    separator: true,
  },
  {
    icon: "k-i-track-changes",
    route: "/view-entry",
    title: "View Entry",
    label: "Entries",
    id: 2,
    selected: selectedHamburgerIndex.value === 2,
  },
  {
    icon: "k-i-windows",
    id: 3,
    selected: selectedHamburgerIndex.value === 3,
    title: "Templates",
    label: "Templates",
    route: "/templates",
  },

  {
    icon: "k-i-folder",
    id: 4,
    selected: selectedHamburgerIndex.value === 4,
    title: "Datasets",
    label: "Datasets",
    route: "/datasets",
  },

  {
    icon: "k-i-user",
    id: 5,
    selected: selectedHamburgerIndex.value === 5,
    title: "Roles",
    label: "Roles",
    route: "/roles",
    hidden: !userData.value?.permissions?.ViewOnly?.includes("View Roles"),
  },
  {
    icon: "k-i-zoom",
    id: 6,
    selected: selectedHamburgerIndex.value === 6,
    title: "View Audit Trail",
    label: "Audit Log",
    route: "/audit-log",
    hidden: !userData.value?.permissions?.ViewOnly?.includes("View Audit Trail"),
  },
]);

export const data = computed(() =>
  items.value.map((item) => {
    const { parentId, ...others } = item;
    if (parentId !== undefined) {
      const parent = items.value.find((parent) => parent.id === parentId);
      return {
        ...others,
        visible: parent.dataExpanded,
        parentId: parentId,
      };
    }
    return item;
  })
);
